import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EfTitle from '@elem/ui/ef-title';
import styles from './index.module.scss';
import SubItem from './SubItem';
import { useGlobal } from '@/utils/useGlobal';

export default function TheComp() {
    const { useLang } = useGlobal();
    const { t } = useLang('theProduct.TraditionalUPS');

    const NAImg = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1732867896062/TraditionalUPS-pc.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1732867895896/TraditionalUPS-h5.jpg',
    };
    const list = [
        {
            text: t('bar1_text'),
            count: t('bar1_count'),
        },
        {
            text: t('bar2_text'),
            count: t('bar2_count'),
        },
    ];
    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfTitle>{t('title')}</EfTitle>
            <div className="title-border-space"></div>
            <EfSection hasAnimation={false} label={t('label')} title={t('subTitle')} desc={t('desc')} />
            <SubItem title={t('subItem1_title')} imgs={NAImg} list={list} />
        </div>
    );
}
